import $ from "jquery";
import * as preact from "preact";

import models from "models/models";
import AccountPanelView2 from "views/AccountPanelView2";
import ManageSubscriptionView from "views/ManageSubscriptionView";

let accountPanelView;

export const render = (element, renderedCallback) => {
  $("title").text("Account - Readlang");

  element.empty();

  const accountPanelContainer = $(`<div class="accountPanelView" />`);
  element.append(accountPanelContainer);

  if (!models.user.hasPremiumAccess()) {
    accountPanelView = new AccountPanelView2({
      el: accountPanelContainer,
      model: models.user,
      accountPage: true,
      smartDefinitions: true,
    });
  } else {
    preact.render(<ManageSubscriptionView />, accountPanelContainer[0]);
  }

  renderedCallback();
};

export const close = () => {
  if (accountPanelView) {
    accountPanelView.remove();
  }
};

export const showHeader = true;
export const name = "accountPage";
